import { render, staticRenderFns } from "./CCMImagingAdd.vue?vue&type=template&id=2b7a0bf0"
import script from "./CCMImagingAdd.vue?vue&type=script&lang=js"
export * from "./CCMImagingAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports